import React, { useState } from 'react';

const Twentythirdtheme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Bronze */
            --bronze-dark: #451a03; 
            --bronze: #b45309; 
            --gold: #f59e0b;
            --bg-dark: #1c1917;
            --bg-card: #292524;
            --text-main: #e7e5e4;
        }

        body { background-color: var(--bg-dark); color: var(--text-main); font-family: 'Cinzel', serif; margin: 0; }
        h1, h2, h3 { font-weight: 400; letter-spacing: 2px; text-transform: uppercase; color: var(--gold); }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
        
        .nav { border-bottom: 1px solid var(--bronze); padding: 30px 0; display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 2rem; color: var(--bronze); }
        .links a { color: var(--text-main); margin-left: 30px; text-decoration: none; font-size: 0.9rem; letter-spacing: 1px; }
        .links a:hover { color: var(--gold); }
        
        .hero { padding: 100px 0; text-align: center; border-bottom: 1px solid #444; }
        .hero h1 { font-size: 3.5rem; margin-bottom: 20px; text-shadow: 0 0 20px rgba(245, 158, 11, 0.3); }
        
        .btn { background: linear-gradient(45deg, var(--bronze), var(--gold)); border: none; padding: 15px 40px; color: black; font-weight: 700; text-transform: uppercase; cursor: pointer; clip-path: polygon(10% 0, 100% 0, 100% 80%, 90% 100%, 0 100%, 0 20%); transition: 0.3s; }
        .btn:hover { filter: brightness(1.2); }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 40px; margin-top: 60px; }
        .card { background: var(--bg-card); padding: 40px; border: 1px solid var(--bronze-dark); position: relative; }
        .card::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 2px; background: linear-gradient(90deg, transparent, var(--gold), transparent); }
        
        .product-img { width: 100%; height: 250px; object-fit: cover; filter: sepia(0.5); transition: 0.5s; }
        .card:hover .product-img { filter: sepia(0); }
        
        .footer { border-top: 1px solid var(--bronze); margin-top: 100px; padding: 60px 0; text-align: center; color: #78716c; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="nav">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="links">
                        <a href="#services">SERVICES</a>
                        <a href="#products">STORE</a>
                        <a href="#contact">CONTACT</a>
                    </div>
                </nav>
                
                <header className="hero">
                    <h1>Timeless Quality</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '40px', color: '#a8a29e'}}>Forged in excellence. Built to last.</p>
                    <button className="btn">Discover More</button>
                </header>
                
                <h2 style={{textAlign: 'center', marginTop: '100px', fontSize: '2.5rem'}}>Our Offerings</h2>
                <div className="grid">
                    {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="card" key={index}>
                            <h3 style={{fontSize: '1.5rem', marginBottom: '15px'}}>{item.name}</h3>
                            <p style={{color: '#a8a29e', lineHeight: 1.6}}>{item.description}</p>
                            <div style={{marginTop: '20px', width: '50px', height: '1px', background: 'var(--gold)'}}></div>
                        </div>
                    ))}
                </div>

                <h2 style={{textAlign: 'center', marginTop: '100px', fontSize: '2.5rem'}}>Artifacts</h2>
                <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{padding: 0}}>
                            <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>
                            <div style={{padding: '30px'}}>
                                <h3>{item.service_name}</h3>
                                {item.price && <div style={{color: 'var(--gold)', fontSize: '1.2rem', margin: '10px 0'}}>₹{item.price}</div>}
                                <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', marginTop: '10px', padding: '10px'}}>Purchase</button>
                            </div>
                        </div>
                     ))}
                </div>
                
                <footer className="footer" id="contact">
                    <h2 style={{color: '#57534e'}}>{get_data.service_name}</h2>
                    <p>{get_data.business_location_name}</p>
                </footer>
            </div>
        </>
    );
};

export default Twentythirdtheme;
